/**
 * SaaS auth "sliding" — capa JS de la vista única login / register / forgot.
 *
 * La ANIMACIÓN es 100% CSS (radio-hack en saas-auth.css); el servidor marca la
 * pantalla de cada URL (deep-links sin JS). Este módulo añade, por secciones:
 *
 *   1 · URL-sync    — pushState al deslizar, popstate (atrás/adelante) marca el
 *                     radio (misma transición CSS que un clic), título y
 *                     enlaces de idioma siguen a la pantalla visible. Respeta
 *                     el prefijo de idioma del path y conserva la query.
 *   2 · Validación  — instantánea en cliente al enviar (required / email /
 *                     política de contraseña / confirmación / términos), con
 *                     los mismos estilos que los errores del servidor. La
 *                     política llega en data-password-policy (PasswordPolicy,
 *                     fuente única server↔cliente) y los textos en data-jsval.
 *   3 · Red         — submit por fetch con Accept: JSON:
 *                       2xx {redirect} → location.assign (login / registro)
 *                       2xx {message}  → caja verde in situ (forgot)
 *                       422 {errors}   → errores por campo + shake
 *                       429 / 419 / red → aviso en el formulario
 *   4 · Reto 2FA    — título de página; auto-submit del código a los 6 dígitos
 *                     (mismo pipeline fetch, sección 3); temporizador de reenvío
 *                     y botón para reenviar por otro canal.
 *   5 · bfcache     — volver con atrás no deja botones en estado busy.
 *   6 · Aviso       — si el sistema pide prefers-reduced-motion, un toast explica
 *                     por qué no hay transición y dónde cambiarlo (ruta según SO).
 *                     Descartable para siempre; cede el turno al sugeridor de
 *                     idioma. Ver saas.motion_notice_* en los ficheros de idioma.
 *   7 · Puerta     — puerta de granero: cierra al cargar y al enviar, y se abre
 *                    por arrastre, clic, teclado o rescate. Sin puerta si el
 *                    sistema pide prefers-reduced-motion.
 *
 * Sin fetch/pushState no se intercepta nada: el POST clásico y los deep-links
 * del servidor siguen siendo el camino completo (progressive enhancement).
 * Los errores (propios o del servidor) llevan data-almc-auth-error-for="<name>"
 * y se limpian en cuanto el usuario corrige el campo.
 */
(function () {
    'use strict';

    // El stage es el sliding ([data-almc-auth]) o el reto 2FA
    // ([data-almc-auth-2fa]) — comparten bundle, mensajes y pipeline fetch.
    var stage = document.querySelector('[data-almc-auth]') || document.querySelector('[data-almc-auth-2fa]');
    if (!stage) return;

    function readJson(attr) {
        try {
            return JSON.parse(stage.getAttribute(attr) || '{}');
        } catch (e) {
            return {};
        }
    }

    var SCREENS = ['login', 'register', 'forgot'];
    var PATH_RE = /^(\/(?:es|en|fr|ca))\/dash\/auth\/(login|register|forgot)\/?$/;
    var TITLES = readJson('data-titles');
    var MSG = readJson('data-jsval');
    var PW = readJson('data-password-policy');
    var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    var radios = {};
    SCREENS.forEach(function (s) {
        radios[s] = document.getElementById('almc-auth-r-' + s);
    });

    /* ── 1 · Sincronización de URL (pushState / popstate / título / idiomas) ── */

    function currentScreen() {
        for (var i = 0; i < SCREENS.length; i++) {
            if (radios[SCREENS[i]] && radios[SCREENS[i]].checked) return SCREENS[i];
        }
        return 'login';
    }

    /** Prefijo de idioma REAL del path actual (fallback: data-locale del server). */
    function localePrefix() {
        var m = window.location.pathname.match(PATH_RE);
        return m ? m[1] : '/' + (stage.getAttribute('data-locale') || 'es');
    }

    function urlFor(screen) {
        return localePrefix() + '/dash/auth/' + screen + window.location.search;
    }

    /** Los enlaces de idioma pasan a apuntar a la pantalla visible. Se reescribe
        SOLO el final del pathname (anclado con $): una query que contuviera
        "/dash/auth/…" (p.ej. ?next=…) jamás debe tocarse. */
    function syncLangLinks(screen) {
        var links = document.querySelectorAll('a[data-almc-auth-lang]');
        for (var i = 0; i < links.length; i++) {
            try {
                var u = new URL(links[i].href);
                u.pathname = u.pathname.replace(
                    /\/dash\/auth\/(?:login|register|forgot)\/?$/,
                    '/dash/auth/' + screen
                );
                links[i].href = u.href;
            } catch (e) { /* href raro: se deja como está */ }
        }
    }

    function applyChrome(screen) {
        if (TITLES[screen]) document.title = TITLES[screen];
        syncLangLinks(screen);
    }

    if (stage.hasAttribute('data-almc-auth') && 'pushState' in history) {
        // Clic/teclado en una pantalla → URL + título acompañan a la animación.
        SCREENS.forEach(function (screen) {
            if (!radios[screen]) return;
            radios[screen].addEventListener('change', function () {
                if (!this.checked) return;
                history.pushState({ almcAuth: screen }, '', urlFor(screen));
                applyChrome(screen);
            });
        });

        // Atrás/adelante → marcar el radio (asignar checked por código no
        // dispara change: no hay pushState doble). Con la puerta activa, el
        // cambio de radio pasa por la misma supresión de transición que el
        // swap por clic (doorSwapWithoutTransition, § 7 más abajo — function
        // elevada: se puede llamar aquí aunque esté más abajo en el fichero,
        // mismo mecanismo que ya usa esta sección con doorShut()/doorOpen()).
        // Sin esto, Atrás/Adelante reproduce el barrido de 0,62s que esta
        // iteración existe para eliminar, y ahora puede ocurrir con la puerta
        // cerrada. Sin puerta (doorEnabled() === false), comportamiento de
        // siempre: el radio-hack transiciona normal. Este handler NO debe
        // disparar pushState — solo reacciona a uno ya ocurrido.
        window.addEventListener('popstate', function () {
            var m = window.location.pathname.match(PATH_RE);
            if (!m) return;
            if (radios[m[2]] && !radios[m[2]].checked) {
                if (doorEnabled()) {
                    doorSwapWithoutTransition(function () { radios[m[2]].checked = true; });
                } else {
                    radios[m[2]].checked = true;
                }
            }
            applyChrome(m[2]);
        });

        // Estado inicial: título bonito + state coherente para el primer atrás.
        history.replaceState({ almcAuth: currentScreen() }, '', window.location.href);
        applyChrome(currentScreen());
    }

    // Los labels-enlace (role=button, tabindex=0) deben responder a Enter y
    // Espacio como cualquier botón: activarlos marca su radio (mismo efecto
    // que el clic) y la transición CSS + pushState siguen su curso normal.
    document.addEventListener('keydown', function (ev) {
        if (ev.key !== 'Enter' && ev.key !== ' ') return;
        var t = ev.target;
        if (t && t.matches && t.matches('label[for^="almc-auth-r-"]')) {
            ev.preventDefault();
            t.click();
        }
    });

    /* ── 2 · Validación instantánea en cliente ─────────────────────────────── */

    function errorNode(name, msg, block) {
        var p = document.createElement('p');
        p.className = 'almc-auth-error' + (block ? ' almc-auth-error--block' : '');
        p.setAttribute('role', 'alert');
        p.setAttribute('data-almc-auth-error-for', name);
        p.textContent = msg;
        return p;
    }

    function setError(input, msg) {
        clearError(input);
        input.setAttribute('aria-invalid', 'true');

        var wrap = input.closest('.almc-auth-field');
        if (wrap) {
            wrap.classList.add('almc-auth-field--invalid');
            if (wrap.classList.contains('almc-auth-field--errblock')) {
                // Campo en columna con mensaje largo: el error va como bloque a
                // ancho completo tras su grid (misma colocación que el servidor).
                var grid = wrap.closest('.almc-auth-grid2') || wrap;
                grid.parentNode.insertBefore(errorNode(input.name, msg, true), grid.nextSibling);
            } else {
                wrap.appendChild(errorNode(input.name, msg, false));
            }
            return;
        }

        var check = input.closest('.almc-auth-check');
        if (check) {
            check.classList.add('almc-auth-check--invalid');
            check.parentNode.insertBefore(errorNode(input.name, msg, true), check.nextSibling);
        }
    }

    function clearError(input) {
        input.removeAttribute('aria-invalid');
        var form = input.form;
        if (form) {
            var errs = form.querySelectorAll('[data-almc-auth-error-for="' + input.name + '"]');
            Array.prototype.forEach.call(errs, function (p) { p.parentNode.removeChild(p); });
        }
        var wrap = input.closest('.almc-auth-field');
        if (wrap) wrap.classList.remove('almc-auth-field--invalid');
        var check = input.closest('.almc-auth-check');
        if (check) check.classList.remove('almc-auth-check--invalid');
    }

    function clearAllErrors(form) {
        Array.prototype.forEach.call(form.querySelectorAll('.almc-auth-input, input[type="checkbox"]'), clearError);
        var flash = form.querySelector('.almc-auth-flash[data-almc-auth-js]');
        if (flash) flash.parentNode.removeChild(flash);
    }

    /** La política llega del servidor; sin spec no se bloquea nada en cliente. */
    function passwordSatisfiesPolicy(v) {
        if (PW.min && v.length < PW.min) return false;
        if (PW.upper && !/[A-Z]/.test(v)) return false;
        if (PW.lower && !/[a-z]/.test(v)) return false;
        if (PW.digit && !/[0-9]/.test(v)) return false;
        if (PW.symbol && !/[^\w]/.test(v)) return false;
        return true;
    }

    /** Devuelve los inputs con error, en orden DOM (el primero recibe focus). */
    function validate(form) {
        var bad = [];
        var isRegister = form.classList.contains('almc-auth-form--register');

        Array.prototype.forEach.call(form.querySelectorAll('.almc-auth-input'), function (input) {
            var v = (input.value || '').trim();
            if (input.required && !v) {
                setError(input, MSG.required); bad.push(input); return;
            }
            if (input.type === 'email' && v && !EMAIL_RE.test(v)) {
                setError(input, MSG.email); bad.push(input); return;
            }
            if (isRegister && input.name === 'password' && v && !passwordSatisfiesPolicy(input.value)) {
                setError(input, MSG.password_weak); bad.push(input); return;
            }
            if (input.name === 'password_confirmation') {
                var pw = form.querySelector('input[name="password"]');
                if (pw && input.value !== pw.value) {
                    setError(input, MSG.password_match); bad.push(input);
                }
            }
        });

        Array.prototype.forEach.call(form.querySelectorAll('input[type="checkbox"][required]'), function (checkbox) {
            if (checkbox.checked) return;
            setError(checkbox, checkbox.getAttribute('data-error-message') || MSG.terms);
            bad.push(checkbox);
        });

        return bad;
    }

    function shake(form) {
        var card = form.querySelector('.almc-auth-card');
        card.classList.remove('almc-auth-shake');
        void card.offsetWidth; // reinicia la animación aunque ya sonara antes
        card.classList.add('almc-auth-shake');
    }

    /* ── 3 · Envío por fetch (sin recarga) ─────────────────────────────────── */

    /** Aviso a nivel de formulario (throttle, sesión caducada, red, éxito forgot). */
    function formFlash(form, msg, mod, extraClass) {
        var card = form.querySelector('.almc-auth-card');
        var old = card.querySelector('.almc-auth-flash[data-almc-auth-js]');
        if (old) old.parentNode.removeChild(old);
        var div = document.createElement('div');
        div.className = 'almc-auth-flash almc-auth-flash--' + mod + (extraClass ? ' ' + extraClass : '');
        div.setAttribute('role', mod === 'ok' ? 'status' : 'alert');
        div.setAttribute('data-almc-auth-js', '1');
        div.textContent = msg;
        var lead = card.querySelector('.almc-auth-lead');
        lead ? lead.parentNode.insertBefore(div, lead.nextSibling) : card.insertBefore(div, card.firstChild);
    }

    function setBusy(form, busy) {
        form.dataset.almcBusy = busy ? '1' : '';
        var btn = form.querySelector('.almc-auth-btn');
        if (btn) {
            btn.disabled = !!busy;
            btn.classList.toggle('almc-auth-btn--busy', !!busy);
        }
    }

    function renderServerErrors(form, errors) {
        var first = null;
        Object.keys(errors).forEach(function (name) {
            var input = form.querySelector('[name="' + name + '"]');
            var msg = Array.isArray(errors[name]) ? errors[name][0] : String(errors[name]);
            if (input) {
                setError(input, msg);
                if (!first) first = input;
            } else {
                formFlash(form, msg, 'ko');
            }
        });
        if (first) first.focus();
    }

    function handleResponse(form, status, data) {
        var ok = status >= 200 && status < 300;

        if (ok && data.redirect) {
            // Defensa en profundidad: el servidor solo emite URLs propias
            // (url()/postAuthTarget), pero si algún día un parámetro controlable
            // acabara en {redirect}, jamás debe sacarnos del origen.
            var dest = null;
            try { dest = new URL(data.redirect, window.location.origin); } catch (e) { /* inválida */ }
            if (dest && dest.origin === window.location.origin) {
                doorDisarmRescue(form);
                // Éxito: la puerta se queda cerrada y navegamos al terminar el
                // cierre, para que el gesto se vea completo.
                var goNow = function () { window.location.assign(dest.href); };
                if (doorEnabled()) setTimeout(goNow, 620); else goNow();
                return;
            }
        }

        // A partir de aquí el envío ha fallado por alguna vía: 422 con errores de
        // campo, 429, 419, mensaje del servidor o genérico. TODAS convergen aquí,
        // así que este es el único sitio donde hay que reabrir.
        doorDisarmRescue(form);
        doorOpen();
        setBusy(form, false);

        if (status === 422 && data.errors) {
            renderServerErrors(form, data.errors);
            shake(form);
        } else if (status === 429) {
            formFlash(form, MSG.throttled, 'warn');
            shake(form);
        } else if (status === 419) {
            // CSRF caducado (página abierta demasiado tiempo): recargar rehace el token.
            formFlash(form, MSG.expired, 'warn');
        } else if (ok && data.message) {
            formFlash(form, data.message, 'ok',
                form.classList.contains('almc-auth-form--forgot') ? 'almc-auth-sent' : '');
        } else {
            formFlash(form, MSG.error_generic, 'ko');
            shake(form);
        }
    }

    function doorArmRescue(form) {
        doorDisarmRescue(form);
        // Este rescate existe para que NADIE se quede detrás de una puerta
        // cerrada — no para dar por muerta una petición que sigue en vuelo. De
        // ahí sus tres decisiones, que van juntas:
        //
        //   · 20 s, no 8. El alta de cuenta manda el correo de verificación de
        //     forma SÍNCRONA: AuthController::sendVerify hace
        //     Mail::to(...)->send(new SaasVerifyEmailMail(...)) con
        //     MAIL_MAILER=smtp y ese mailable NO implementa ShouldQueue (lo
        //     mismo en el forgot con SaasResetPasswordMail). Con un SMTP lento
        //     el servidor ya ha CREADO la cuenta y sigue bloqueado hablando con
        //     el relay. 8 s se agotan ahí dentro con total normalidad.
        //
        //   · NO se reactiva el botón (nada de setBusy(form, false) aquí). Si
        //     lo reactivásemos, el usuario reenviaría el alta que el servidor
        //     está completando en ese mismo instante y se comería un 422 "ese
        //     email ya está registrado" sobre una cuenta que es SUYA y cuyo
        //     correo de verificación sí salió — y concluiría que el registro
        //     está roto. El botón se reactiva solo cuando la respuesta llega
        //     (handleResponse) o cuando la red falla de verdad (catch del
        //     fetch): ahí sí sabemos que no hay nada en vuelo.
        //     Si "arreglas" esto reactivando el botón, vuelves a abrir la
        //     puerta al doble envío en el embudo de captación. No lo hagas.
        //
        //   · Mensaje de ESPERA (jsval_slow), no de error. "No se ha podido
        //     completar la operación, inténtalo de nuevo" sería literalmente
        //     falso: lo más probable es que sí se completara.
        //
        // El temporizador vive EN el form (form._almcDoorRescue), no en una
        // variable de módulo: login, registro y forgot coexisten en el mismo
        // DOM (radio-hack de una sola vista) y pueden tener envíos solapados
        // — un var compartido haría que armar el rescate de uno cancelase el
        // del otro, dejando ese primer formulario sin nadie que lo vigile.
        form._almcDoorRescue = setTimeout(function () {
            form._almcDoorRescue = null;
            doorOpen();
            // Login y el verify del 2FA NO envían ningún correo, así que el
            // mensaje que promete uno sería falso ahí. Y como el botón ya no se
            // reactiva a propósito (evitar el doble alta), hay que decir cuál es
            // la salida en vez de dejar al usuario mirando.
            var slowKey = (form.classList.contains('almc-auth-form--login') ||
                           form.classList.contains('almc-auth-2fa-form'))
                ? MSG.slow_login
                : MSG.slow;
            formFlash(form, slowKey || MSG.error_generic, 'warn');
        }, 20000);
    }

    function doorDisarmRescue(form) {
        if (form && form._almcDoorRescue) {
            clearTimeout(form._almcDoorRescue);
            form._almcDoorRescue = null;
        }
    }

    function submitAjax(form) {
        setBusy(form, true);
        doorShut();
        doorArmRescue(form);
        fetch(form.action, {
            method: 'POST',
            body: new FormData(form),
            credentials: 'same-origin',
            headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        }).then(function (res) {
            return res.json().catch(function () { return {}; }).then(function (data) {
                handleResponse(form, res.status, data);
            });
        }).catch(function () {
            doorDisarmRescue(form);
            doorOpen();                 // error de red: la puerta NO puede quedarse echada
            setBusy(form, false);
            formFlash(form, MSG.error_generic, 'ko');
            shake(form);
        });
    }

    if (typeof window.fetch === 'function' && MSG.required) {
        Array.prototype.forEach.call(document.querySelectorAll('.almc-auth-ajax'), function (form) {
            /*
             * El antibot se engancha ANTES que el listener de abajo: los
             * listeners de submit corren en orden de registro, así que el suyo
             * pone el campo `antibot_token` justo a tiempo para que el FormData
             * de submitAjax() lo recoja. Al revés llegaría tarde y cada envío
             * saldría sin token.
             *
             * Normalmente ya se enganchó solo (antibot-form.js viaja en
             * public-core, que va antes que este bundle y hace autoAttach por
             * los data-antibot-*). attach() es idempotente, así que esta llamada
             * es la red por si ese orden cambiara: lo que NO puede pasar es que
             * el enganche quede detrás de este listener.
             */
            if (window.AntibotForm && form.getAttribute('data-antibot-profile')) {
                window.AntibotForm.attach(form, {
                    profile: form.getAttribute('data-antibot-profile'),
                    route: form.getAttribute('data-antibot-route'),
                });
            }

            form.addEventListener('submit', function (ev) {
                /*
                 * Con el challenge todavía en vuelo, el módulo antibot ENCOLA el
                 * envío (llama a preventDefault) y lo relanza él solo al
                 * resolverse. preventDefault NO detiene a los demás listeners del
                 * mismo elemento: sin esta salida, este handler ya habría
                 * disparado su fetch sin token y el relanzamiento haría un
                 * SEGUNDO POST — en login, dos intentos contra el throttle; en el
                 * alta, dos cuentas. Cuando el token ya está puesto, el módulo no
                 * previene nada y esto no se activa.
                 */
                if (ev.defaultPrevented) return;

                ev.preventDefault();
                if (form.dataset.almcBusy === '1') return;
                clearAllErrors(form);
                var bad = validate(form);
                if (bad.length) {
                    shake(form);
                    bad[0].focus();
                    return;
                }
                submitAjax(form);
            });

            // Native feel: el error de un campo se esfuma en cuanto lo corriges.
            form.addEventListener('input', function (ev) {
                var t = ev.target;
                if (t && (t.classList.contains('almc-auth-input') || t.type === 'checkbox')) clearError(t);
            });
            form.addEventListener('change', function (ev) {
                if (ev.target && ev.target.type === 'checkbox') clearError(ev.target);
            });
        });
    }

    /* ── 4 · Reto 2FA: título, auto-submit a los 6 dígitos, reenvío ────────── */

    var twofa = document.querySelector('[data-almc-auth-2fa]');
    if (twofa) {
        if (twofa.getAttribute('data-title')) document.title = twofa.getAttribute('data-title');

        // Auto-submit al completar 6 dígitos (viaja por el pipeline fetch
        // genérico de la sección 3; los códigos de recuperación TOTP, más
        // largos, se envían con el botón).
        var codeInput = document.getElementById('almc-auth-2fa-code');
        if (codeInput) {
            codeInput.addEventListener('input', function () {
                var v = this.value;
                if (/^[0-9]{6}$/.test(v) && this.form.dataset.almcBusy !== '1' && this.form.requestSubmit) {
                    this.form.requestSubmit();
                }
            });
        }

        var waitEl = twofa.querySelector('[data-almc-2fa-wait]');
        var secEl = twofa.querySelector('[data-almc-2fa-sec]');
        var primaryBtn = twofa.querySelector('.almc-auth-2fa-resend-btn[data-channel=""]');

        function startResendTimer() {
            if (!waitEl || !secEl || !primaryBtn) return;
            var left = parseInt(waitEl.getAttribute('data-seconds'), 10) || 60;
            waitEl.style.display = '';
            secEl.textContent = left;
            primaryBtn.disabled = true;
            (function tick() {
                left--;
                if (left <= 0) {
                    waitEl.style.display = 'none';
                    primaryBtn.disabled = false;
                    return;
                }
                secEl.textContent = left;
                setTimeout(tick, 1000);
            })();
        }
        startResendTimer();

        Array.prototype.forEach.call(twofa.querySelectorAll('.almc-auth-2fa-resend-btn'), function (btn) {
            btn.addEventListener('click', function () {
                var form = twofa.querySelector('.almc-auth-ajax');
                var fd = new FormData();
                fd.append('_token', form.querySelector('input[name="_token"]').value);
                if (btn.getAttribute('data-channel')) fd.append('channel', btn.getAttribute('data-channel'));
                btn.disabled = true;

                /*
                 * El reenvío NO es un submit: es un fetch con su propio FormData,
                 * así que AntibotForm.attach() no lo ve y el token hay que
                 * pedirlo a mano. Sin esto, `saas-2fa-resend` anotaría
                 * `would_block` en el 100 % de los reenvíos legítimos y su
                 * contador —el que se mira para decidir el paso a enforce— no
                 * diría nada.
                 *
                 * Si la emisión falla, issueToken resuelve null y se envía sin
                 * token: el perfil es fail-open, así que el servidor lo deja
                 * pasar igual. Nunca se bloquea al usuario por esto.
                 */
                var conToken = (window.AntibotForm && window.AntibotForm.issueToken)
                    ? window.AntibotForm.issueToken('light', 'saas-2fa-resend')
                    : Promise.resolve(null);

                conToken.then(function (token) {
                    if (token) fd.append('antibot_token', token);

                    return fetch(twofa.getAttribute('data-resend-url'), {
                        method: 'POST',
                        body: fd,
                        credentials: 'same-origin',
                        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
                    }).then(function (res) {
                        return res.json().catch(function () { return {}; }).then(function (data) {
                            if (res.ok && data.sent) {
                                formFlash(form, 'Código reenviado por ' + data.channel + ' a ' + data.recipient_masked, 'ok');
                                var chip = twofa.querySelector('[data-almc-2fa-recipient]');
                                if (chip && data.recipient_masked) chip.textContent = data.recipient_masked;
                                startResendTimer();                    // gobierna el botón primario
                                if (btn !== primaryBtn) btn.disabled = false;
                            } else {
                                btn.disabled = false;
                                if (res.status === 401) {
                                    formFlash(form, MSG.expired, 'warn');
                                } else {
                                    formFlash(form, (data && (data.error || data.message)) || MSG.error_generic, 'ko');
                                }
                            }
                        });
                    });
                }).catch(function () {
                    btn.disabled = false;
                    formFlash(form, MSG.error_generic, 'ko');
                });
            });
        });
    }

    /* ── 5 · bfcache: atrás no deja botones colgados en busy ni puerta echada ─ */

    window.addEventListener('pageshow', function (ev) {
        if (!ev.persisted) return;
        Array.prototype.forEach.call(document.querySelectorAll('.almc-auth-ajax'), function (form) {
            setBusy(form, false);
            // El rescate que quedó armado antes de navegar ya no vigila nada:
            // si se le deja vivo, al restaurar suelta el aviso de "esto está
            // tardando" sobre una petición que terminó hace rato.
            doorDisarmRescue(form);
        });

        // La puerta también viaja en el bfcache: enviar → doorShut() → navegar
        // al panel → Atrás restaura el DOM con almc-auth-door-shut TODAVÍA
        // puesta. Ni el temporizador inline de 4 s ni el de la pista se
        // rearman, así que sin esto el usuario vuelve a un panel azul sobre el
        // login, sin pista y sin nada que le diga qué hacer (clicar seguiría
        // funcionando, pero nadie se lo cuenta).
        doorOpen();
    });

    /* ── 6 · Aviso "animaciones desactivadas" ──────────────────────────────────
       El bloque prefers-reduced-motion de saas-auth.css anula toda la
       coreografía. Correcto: es la preferencia del usuario. Pero quien apagó
       "Efectos de animación" en Windows por rendimiento no sabe que eso apaga
       también las transiciones de la web, y lo vive como un fallo del sitio.
       Este aviso lo explica, dice dónde cambiarlo y se descarta para siempre
       con un clic. Nunca presiona: quien tiene reduced-motion por accesibilidad
       (vestibular, migrañas) es tan destinatario como el otro. */

    (function motionNotice() {
        var root = document.getElementById('almcMotionNotice');
        if (!root || !window.matchMedia) return;

        var DISMISS_KEY = 'almc_motion_notice_dismissed';
        var SESSION_KEY = 'almc_motion_notice_session';

        // Descartado para siempre, o cerrado en esta visita: no insistir.
        try { if (localStorage.getItem(DISMISS_KEY)) return; } catch (e) {}
        try { if (sessionStorage.getItem(SESSION_KEY)) return; } catch (e) {}

        var mq = window.matchMedia('(prefers-reduced-motion: reduce)');
        if (!mq.matches) return;

        var hints = {};
        try { hints = JSON.parse(root.getAttribute('data-motion-hints') || '{}'); } catch (e) {}

        // Frases COMPLETAS por sistema, no una plantilla con la ruta variable:
        // en macOS el ajuste ("Reducir movimiento") se DESACTIVA, así que un
        // "actívalas en X" sería una instrucción falsa. iOS va ANTES que macOS
        // a propósito y NO debe fusionarse con esa rama: todo user-agent de
        // iPhone/iPad/iPod incluye la subcadena "like Mac OS X", así que si
        // macOS fuera primero capturaría también a iOS y le daría la ruta de
        // escritorio (Ajustes del Sistema → Accesibilidad → Pantalla), que en
        // iOS no existe — ahí el ajuste vive en Accesibilidad → Movimiento. Por
        // eso iOS usa el fallback "generic" ("revisa los ajustes de accesibilidad
        // de tu sistema"), que es correcto en vez de una ruta de macOS falsa.
        var ua = navigator.userAgent || '';
        var osKey = /Windows/i.test(ua) ? 'windows'
                  : /iPhone|iPad|iPod/i.test(ua) ? 'generic'
                  : /Mac OS X|Macintosh/i.test(ua) ? 'macos'
                  : 'generic';
        var hintEl = root.querySelector('[data-motion-hint]');
        if (hintEl) hintEl.textContent = hints[osKey] || hints.generic || '';

        function hide() { root.hidden = true; }

        var closeBtn = root.querySelector('[data-motion-close]');
        if (closeBtn) {
            closeBtn.addEventListener('click', function () {
                try { sessionStorage.setItem(SESSION_KEY, '1'); } catch (e) {}
                hide();
            });
        }

        var dismissBtn = root.querySelector('[data-motion-dismiss]');
        if (dismissBtn) {
            dismissBtn.addEventListener('click', function () {
                try { localStorage.setItem(DISMISS_KEY, '1'); } catch (e) {}
                hide();
            });
        }

        // El sugeridor de idioma manda: es más accionable y ocupa el mismo
        // hueco (ambos son toasts fijos abajo-centro). Si sigue en pantalla a
        // los 1600 ms, este aviso cede el turno SIN gastar sessionStorage, para
        // reaparecer en cuanto aquel deje de salir.
        setTimeout(function () {
            // Revalida: si el usuario reactivó las animaciones durante estos
            // 1600 ms, el listener de "change" aún no estaba enganchado (se
            // engancha más abajo) y no lo habría sabido. Sin este guard el
            // aviso aparecería igualmente y mentiría sobre el estado actual.
            if (!mq.matches) return;

            var lang = document.getElementById('almcLangSuggest');
            if (lang && !lang.hidden) return;

            root.hidden = false;

            // Si el usuario activa las animaciones con la página abierta, el
            // aviso se retira solo: confirmación inmediata, sin recargar. El
            // listener se engancha AQUÍ y no antes, para no hacer aparecer el
            // aviso a quien acaba de desactivarlas a propósito.
            var onChange = function (ev) { if (!ev.matches) hide(); };
            if (mq.addEventListener) mq.addEventListener('change', onChange);
            else if (mq.addListener) mq.addListener(onChange);
        }, 1600);
    })();

    /* ── 7 · Puerta de granero: apertura y arrastre ────────────────────────────
       La puerta arranca cerrada (la cierra el script inline de la vista) y se
       abre por CINCO vías. No son cinco por capricho: una puerta cerrada
       delante de un login es un cerrojo, y la WCAG 2.2 (2.5.7) exige
       alternativa de un solo puntero a cualquier gesto de arrastre.

         1. arrastre con ratón, dedo o lápiz
         2. clic o toque en cualquier punto
         3. Enter, espacio o flecha con la puerta enfocada
         4. el foco llega al formulario o a la primera parada de tabulación (el
            radio de pantalla, hermano previo de <main>): un listener 'focusin'
            sobre .almc-auth-forms y otro 'focus' por radio abren la puerta en
            el acto. Es la vía que cierra la WCAG 2.4.11 (Focus Not Obscured) —
            razonamiento completo donde se instalan, más abajo en este bloque.
         5. respaldo automático, en DOS escalones que nunca coinciden:
              · 4s, lo arma el script inline de la vista, y solo dispara si el
                bundle NO llegó a instalar el mecanismo de apertura (se desarma
                con html[data-almc-door-live], que se pone al final de este
                bloque). Es la red para "el bundle nunca arrancó".
              · 15s, lo arma este bundle (doorArmBackup). Es la red para "el
                bundle está vivo pero el usuario no toca nada".
            El escalón corto NO puede quedarse como red universal: a los 4,0s
            abría la puerta en TODA carga sana, antes de que el usuario tuviera
            ocasión de abrirla él.

       Con prefers-reduced-motion no hay puerta en absoluto: el CSS anula toda
       transición con !important, así que cerrada NO se abriría jamás.

       Se declaran como `function` y no como `var` porque la sección 3 las llama
       y está ANTES en el fichero: solo las declaraciones de función se elevan. */

    var doorStage = document.querySelector('.almc-auth-stage');
    // El panel se resuelve AQUÍ y no dentro del bloque de abajo porque
    // doorShut()/doorOpen() gobiernan sus atributos ARIA y las llama la sección
    // 3, que está antes en el fichero.
    var doorBrand = doorStage ? doorStage.querySelector('.almc-auth-brand') : null;
    var doorHint = document.querySelector('[data-door-hint]');
    var doorHintTimer = null;
    // El setTimeout pendiente de "cerrar → cambiar de pantalla" (doorOnSwapClick,
    // más abajo). Vive a este nivel, no dentro del bloque de la puerta, porque
    // doorOpen() (aquí mismo, y la llama también la sección 3, antes en el
    // fichero) tiene que poder cancelarlo si alguien reabre la puerta a medio
    // camino: si no, el swap pendiente dispara igualmente 620ms después y pisa
    // a ciegas el estado que dejó ese doorOpen() (Hallazgo 1).
    var doorSwapTimer = null;
    // ¿Quedó INSTALADO el mecanismo de apertura (clic, teclado, arrastre)? El
    // bloque que engancha esos listeners se evalúa UNA sola vez al arrancar,
    // mientras que doorEnabled() se relee en vivo. Sin esta marca, cargar por
    // debajo de 720px —una ventana acoplada a media pantalla en un portátil de
    // 1366 son ~683px— y ensanchar después dejaba una puerta que SÍ cerraba
    // (doorShut() relee innerWidth) pero que no respondía a clic, ni a teclado,
    // ni a arrastre, y que encima anunciaba un role="button" inerte. Cierra
    // además el desacuerdo de ~15px entre window.innerWidth (que incluye la
    // barra de scroll) y el @media del CSS: cerrar solo es legítimo si el
    // mecanismo de apertura se llegó a montar de verdad.
    var doorReady = false;
    // Respaldo LARGO de apertura, armado por el bundle (no por el inline). El
    // rescate de 4s de la vista ya no dispara cuando este bundle está vivo
    // —abría la puerta antes de que el usuario llegara a tocarla, vaciando de
    // sentido la interacción—, así que la invariante "nadie se queda tapiado"
    // pasa a sostenerla este temporizador. El plazo se negocia; la invariante no.
    var doorBackupTimer = null;
    var DOOR_BACKUP_MS = 15000;

    function doorEnabled() {
        if (!doorStage) return false;
        if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return false;
        return window.innerWidth >= 720;
    }

    function doorIsShut() {
        return !!doorStage && doorStage.classList.contains('almc-auth-door-shut');
    }

    /** Arma (o rearma) el respaldo largo: si a los 15s la puerta sigue cerrada,
        se abre sola. Es la red que sustituye al rescate de 4s del inline en
        cuanto este bundle está vivo. Lo cancela doorOpen() —por CUALQUIER vía—,
        para no reabrir sola una puerta que ya se abrió (y que puede haberse
        vuelto a cerrar por un envío en vuelo: reabrirla ahí sería reabrirla en
        mitad de un momento raro). Se rearma en doorSwapTo(): cambiar de
        pantalla deja la puerta cerrada otra vez, y ese estado es idéntico al de
        la carga inicial — usuario delante de una puerta echada. */
    function doorArmBackup() {
        if (doorBackupTimer) { clearTimeout(doorBackupTimer); doorBackupTimer = null; }
        doorBackupTimer = setTimeout(function () {
            doorBackupTimer = null;
            if (doorIsShut()) doorOpen();
        }, DOOR_BACKUP_MS);
    }

    var doorVideo = document.querySelector('[data-door-video]');

    /** Arranca el vídeo del hueco, copiando data-src a src la PRIMERA vez.
        Hasta ese momento el navegador no ha pedido el fichero: esa es toda la
        garantía de "con movimiento reducido no se descarga". doorEnabled() ya
        devuelve false con prefers-reduced-motion y por debajo de 720 px. */
    function doorVideoPlay() {
        if (!doorVideo || !doorEnabled()) return;

        // El cuerpo ENTERO va en try/catch, igual que doorVideoPause(), y aquí
        // importa más: a esta función la llama doorShut(), y a doorShut() lo
        // llama submitAjax() ANTES de armar el rescate y de lanzar el fetch. Una
        // excepción SÍNCRONA aquí —load() y play() pueden lanzar, no solo
        // rechazar la promesa— se llevaría por delante todo lo que viene detrás:
        // sin fetch, sin temporizador armado, el botón en busy para siempre y la
        // puerta echada. O sea, el usuario tapiado, que es justo la invariante
        // que sostiene esta pantalla. El .catch() de la promesa de play() NO
        // cubre ese caso: solo cubre el rechazo asíncrono.
        try {
            var fuente = doorVideo.querySelector('source[data-src]');
            if (fuente && !fuente.getAttribute('src')) {
                fuente.setAttribute('src', fuente.getAttribute('data-src'));
                // muted por PROPIEDAD además de por atributo: hay navegadores que
                // solo miran la propiedad para permitir la reproducción automática,
                // y sin ella el play() se rechaza en silencio.
                doorVideo.muted = true;
                doorVideo.load();
            }

            // play() devuelve una promesa que RECHAZA si el navegador bloquea la
            // reproducción. No es un fallo nuestro y no puede tumbar el login.
            var p = doorVideo.play();
            if (p && p.catch) { p.catch(function () {}); }
        } catch (e) { /* nunca romper el login */ }
    }

    function doorVideoPause() {
        if (!doorVideo) return;
        try { doorVideo.pause(); } catch (e) { /* nunca romper el login */ }
    }

    function doorShut() {
        // doorReady antes que doorEnabled(): una puerta cuyo mecanismo de
        // apertura nunca se instaló no debe cerrarse JAMÁS, aunque el ancho
        // actual diga que sí (ver doorReady, arriba).
        if (!doorReady || !doorEnabled()) return;
        doorStage.classList.add('almc-auth-door-shut');
        doorSpin(1);
        doorAria(true);
        doorVideoPlay();     // la puerta se aparta: el hueco queda a la vista
    }

    // M1 (revisión final del Hallazgo I1/§7): doorOpen() es reentrante de
    // verdad. focus() (más abajo en este cuerpo) dispara un focusin SÍNCRONO
    // sobre .almc-auth-forms —o un focus síncrono sobre el radio, si la vía
    // fue tabular hasta él (§7, listeners de foco)— mientras la clase de
    // cerrado TODAVÍA está puesta (se retira DESPUÉS del focus, más abajo), y
    // ese listener relee doorIsShut() → true y vuelve a llamar a doorOpen().
    // Hoy termina en profundidad 2 sin efecto observable, porque en la
    // llamada interna document.activeElement ya no es doorBrand (la guarda de
    // la línea de abajo es falsa) y el resto del cuerpo es idempotente — pero
    // eso es accidental, no garantizado. Cualquier añadido futuro no
    // idempotente a este cuerpo (una métrica, un doorArmBackup con estado, un
    // history.replaceState) se dispararía dos veces en silencio, y nada en la
    // suite lo detectaría (no ejecuta JS). doorOpening cierra la puerta a esa
    // clase de bug sin reordenar ni una línea del cuerpo existente.
    var doorOpening = false;
    function doorOpen() {
        if (!doorStage || doorOpening) return;
        doorOpening = true;
        try {
            // Cancela el swap de pantalla pendiente (doorOnSwapClick, § 7): si
            // alguien reabre la puerta a medio camino de un cierre-para-cambiar, el
            // setTimeout de 620ms ya no debe disparar — dispararía igualmente sobre
            // un doorOpen() ya ocurrido y dejaría las ruedas congeladas en cerrado
            // con la clase diciendo abierta (Hallazgo 1, revisión adversarial).
            if (doorSwapTimer) { clearTimeout(doorSwapTimer); doorSwapTimer = null; }
            // Y cancela el respaldo largo: la puerta ya está abierta, así que ese
            // temporizador solo podría reabrirla sola más tarde, en mitad de un
            // cierre deliberado (enviar el formulario cierra la puerta y navega).
            if (doorBackupTimer) { clearTimeout(doorBackupTimer); doorBackupTimer = null; }
            // El foco se mueve ANTES de que doorAria(false) retire el tabindex. Si
            // no, el elemento deja de ser enfocable en mitad del propio manejador de
            // keydown y el navegador manda el foco a <body>: el usuario de teclado se
            // queda sin punto de partida justo en la vía que existe para cumplir la
            // WCAG 2.5.7, y el siguiente Tab reempieza desde arriba del documento.
            if (doorBrand && document.activeElement === doorBrand) {
                // currentScreen() ya sabe recorrer radios/SCREENS (§ 1, línea ~68):
                // reimplementar el mismo bucle aquí solo divergiría en silencio el
                // día que SCREENS cambie.
                var pantalla = currentScreen();
                var primero = doorStage.querySelector('.almc-auth-form--' + pantalla + ' .almc-auth-input')
                           || doorStage.querySelector('.almc-auth-2fa-form .almc-auth-input');
                if (primero) primero.focus(); else doorBrand.blur();
            }
            doorStage.classList.remove('almc-auth-door-shut');
            doorSpin(0);
            doorAria(false);
            if (doorHintTimer) { clearTimeout(doorHintTimer); doorHintTimer = null; }
            if (doorHint) doorHint.hidden = true;
            doorVideoPause();    // la puerta lo tapa: descodificar detrás de un panel
                                 // opaco solo gasta batería
        } finally {
            doorOpening = false;
        }
    }

    /** Los atributos de botón del panel existen SOLO mientras la puerta está
        cerrada, que es cuando el panel de verdad se comporta como un botón.

        Dejarlos puestos con la puerta abierta tiene dos costes, y el segundo es
        el grave: (a) el panel se anuncia de por vida como un botón que no hace
        nada y añade una parada de tabulación; (b) role="button" exige hijos
        PRESENTACIONALES, y este subárbol contiene un <a> real (el logo) y un
        <h2> — contenido interactivo dentro de role="button" es ARIA inválido:
        la tecnología asistiva aplana el subárbol, así que enlace y encabezado
        pierden su semántica pero el <a> sigue siendo enfocable con Tab, o sea
        una parada sin etiqueta. */
    function doorAria(on) {
        if (!doorBrand) return;
        if (!on) {
            doorBrand.removeAttribute('role');
            doorBrand.removeAttribute('tabindex');
            doorBrand.removeAttribute('aria-label');
            // El logo recupera su sitio en el orden de tabulación: con la puerta
            // abierta vuelve a ser un enlace normal.
            var logoOff = doorBrand.querySelector('.almc-auth-logo-link');
            if (logoOff) logoOff.removeAttribute('tabindex');
            return;
        }
        doorBrand.setAttribute('role', 'button');
        doorBrand.setAttribute('tabindex', '0');
        // Un aria-label="" deja un role="button" SIN nombre accesible, que es
        // peor que no ponerlo: omitirlo al menos deja que el contenido del
        // panel haga de nombre. Solo se escribe si hay texto de verdad.
        var label = doorStage.getAttribute('data-door-label') || '';
        if (label) doorBrand.setAttribute('aria-label', label);
        else doorBrand.removeAttribute('aria-label');
        // role="button" hace presentacionales a sus hijos, así que el <a> del logo
        // pierde su nombre accesible PERO seguiría siendo parada de tabulación: una
        // parada muda. Se saca del orden mientras la puerta es un botón. El <h2>
        // también se aplana, y eso es inherente y correcto: cerrada, el panel ES un
        // botón, y su nombre lo da el aria-label de arriba.
        var logoOn = doorBrand.querySelector('.almc-auth-logo-link');
        if (logoOn) logoOn.setAttribute('tabindex', '-1');
    }

    /** Gira las ruedas. ratio 0 = abierta, 1 = cerrada del todo.
        720° sobre el recorrido completo es una licencia DELIBERADA: la rotación
        físicamente exacta caería en ~38° por fotograma, y como la rueda tiene 5
        radios su dibujo se repite cada 72°, así que parecería parada o girando
        hacia atrás. No lo "corrijas" a la exacta. */
    function doorSpin(ratio) {
        var deg = -720 * ratio;
        var wheels = document.querySelectorAll('.almc-auth-wheel');
        for (var i = 0; i < wheels.length; i++) {
            wheels[i].style.setProperty('--almc-auth-wheel-deg', deg + 'deg');
        }
    }

    /** Ejecuta fn() con las transiciones de la puerta suprimidas y fuerza un
        reflujo entre medias: la MISMA secuencia que necesitan doorSwapTo (§ 7,
        más abajo) y el popstate de Atrás/Adelante (§ 1, arriba) para cambiar de
        pantalla sin el barrido de 0,62s que esta iteración existe para
        eliminar. Se declara `function` y no `var` por lo mismo que doorShut()/
        doorOpen(): la sección 1 la llama y está antes en el fichero, y solo las
        declaraciones de función se elevan. doorStage nunca es null aquí: los
        dos sitios que llaman a esta función lo hacen solo tras comprobar
        doorEnabled(), que ya exige doorStage. */
    function doorSwapWithoutTransition(fn) {
        doorStage.classList.add('almc-auth-door-swapping');
        fn();
        doorStage.offsetWidth;              // reflujo forzado: sin esta lectura
                                             // el navegador agrupa los cambios y
                                             // la transición vuelve a verse
        doorStage.classList.remove('almc-auth-door-swapping');
    }

    /** Arma (o rearma) el temporizador de la pista: a los 800 ms, si la puerta
        SIGUE cerrada, hace visible el texto que explica cómo abrirla. Se llama
        al cargar la página (al final de este bloque) y tras cada cambio de
        pantalla (doorSwapTo, § 7 más abajo): la pista es la ÚNICA indicación
        textual de cómo abrir la puerta, y quien cambia de pantalla con la
        puerta ya cerrada antes nunca llegó a verla (Hallazgo 2, revisión
        adversarial). */
    function doorArmHint() {
        if (doorHintTimer) { clearTimeout(doorHintTimer); doorHintTimer = null; }
        doorHintTimer = setTimeout(function () {
            if (doorIsShut() && doorHint) doorHint.hidden = false;
        }, 800);
    }

    if (doorStage && doorEnabled()) {
        // El inline marcó el <html>; a partir de aquí manda la clase del stage.
        // doorSpin(1) NO hace girar nada aquí: el CSS ya dejó las ruedas en
        // -720deg mientras duraba html[data-almc-door="shut"], así que este
        // setProperty escribe el MISMO valor computado y no hay transición. Es
        // justo lo que se busca — la puerta está quieta y cerrada, unas ruedas
        // girando solas al cargar serían movimiento sin puerta que lo explique.
        if (document.documentElement.getAttribute('data-almc-door') === 'shut') {
            doorStage.classList.add('almc-auth-door-shut');
            document.documentElement.removeAttribute('data-almc-door');
            doorSpin(1);
        }

        var brand = doorBrand;

        if (brand) {
            // Los atributos de botón siguen al estado real de la puerta: si el
            // rescate inline ya la abrió antes de que llegara este bundle, no
            // se ponen siquiera.
            doorAria(doorIsShut());

            // Vía 2 · clic o toque. El umbral del arrastre (más abajo) evita que
            // un arrastre cuente además como clic. Con la puerta cerrada el
            // panel es un botón, no un enlace: el logo (real <a> dentro del
            // panel) no debe navegar, o un clic ahí saca al usuario del login
            // en vez de abrir la puerta. preventDefault() también cubre el
            // teclado: activar un <a> enfocado con Enter dispara un evento de
            // clic, así que pasa por este mismo camino. Con la puerta abierta
            // no se toca nada y el logo navega con normalidad.
            //
            // justDragged cubre lo que el teclado no tiene: tras un arrastre
            // real (decided === true, más abajo) el navegador SIGUE emitiendo
            // un click sintético sobre el mismo puntero al soltar — el umbral
            // solo evita que un arrastre CORTO cuente como tal, no suprime ese
            // click posterior. Sin esta guarda repetiría la decisión que el
            // arrastre ya tomó: si arrastrar cerró la puerta, este click la
            // reabriría en el acto; si arrastrar empezó sobre el logo y la
            // dejó abierta, este click navegaría. Se arma solo en pointerup
            // (más abajo) y se consume aquí mismo, así que un clic normal
            // (sin arrastre de por medio) no se ve afectado.
            brand.addEventListener('click', function (ev) {
                if (justDragged) {
                    justDragged = false;
                    ev.preventDefault();
                    return;
                }
                if (doorIsShut()) {
                    ev.preventDefault();   // con la puerta cerrada el panel es un boton,
                    doorOpen();            // no un enlace: el logo no debe navegar
                }
            });

            // Vía 3 · teclado.
            brand.addEventListener('keydown', function (ev) {
                var k = ev.key;
                if (k === 'Enter' || k === ' ' || k === 'Spacebar' ||
                    k === 'ArrowLeft' || k === 'ArrowRight') {
                    if (doorIsShut()) { ev.preventDefault(); doorOpen(); }
                }
            });
        }

        // ── El cambio de pantalla pasa por la puerta ──────────────────────────
        // Se cierra una puerta y se te indica cómo abrir la siguiente, en vez de
        // ver el panel viajar de una mitad a la otra. Sin JS, estos mismos labels
        // siguen cambiando de pantalla al instante: es la degradación correcta y
        // por eso NO se toca el marcado.
        var doorSwapLabels = doorStage.querySelectorAll('label[for^="almc-auth-r-"]');

        function doorSwapTo(radio) {
            // Sin transición: el radio-hack cambia a la vez la posición de reposo
            // del panel, el lado de la piel y el signo de --almc-auth-door-x, y
            // con transiciones activas eso se ve como un barrido. Misma
            // secuencia que el popstate de Atrás/Adelante (§ 1): compartida en
            // doorSwapWithoutTransition para no duplicarla.
            doorSwapWithoutTransition(function () {
                radio.checked = true;

                // Asignar checked por código NO dispara change: hay que emitirlo
                // o la sección 1 no hace pushState ni sincroniza título e idiomas.
                var ev = document.createEvent('HTMLEvents');
                ev.initEvent('change', true, false);
                radio.dispatchEvent(ev);
            });

            // Revalida antes de tocar las ruedas: si esto llega desde el
            // setTimeout de doorOnSwapClick y entretanto alguien reabrió la
            // puerta, doorOpen() ya dejó las ruedas en 0 — forzarlas aquí a
            // cerrado las congelaría en -720° con la clase diciendo abierta
            // (Hallazgo 1). En el camino normal la puerta sigue cerrada y esto
            // no cambia nada (doorShut() ya dejó las ruedas en 1).
            if (doorIsShut()) doorSpin(1);

            // La pista es la ÚNICA indicación textual de cómo abrir la puerta:
            // rearmarla aquí para que quien cambió de pantalla y aún no ha
            // abierto la puerta la vea a los 800 ms, igual que en la carga
            // inicial (Hallazgo 2).
            doorArmHint();
            // Y por lo mismo el respaldo largo: tras el cambio la puerta queda
            // cerrada otra vez, exactamente igual que al cargar. Sin rearmarlo,
            // quien cambia de pantalla y luego se queda quieto se queda tapiado
            // (el respaldo se consumió o lo canceló el doorOpen() de antes).
            doorArmBackup();
        }

        function doorOnSwapClick(ev) {
            if (!doorEnabled()) return;                 // sin puerta, comportamiento nativo
            var destino = document.getElementById(this.getAttribute('for'));
            if (!destino || destino.checked) return;

            ev.preventDefault();

            // Otra interacción de swap antes de que la anterior disparase
            // (Hallazgo 1: doble clic sobre el mismo label) — cancelarla evita
            // el doble pushState. Mismo patrón que form._almcDoorRescue, más
            // arriba en este fichero.
            if (doorSwapTimer) { clearTimeout(doorSwapTimer); doorSwapTimer = null; }

            if (doorIsShut()) { doorSwapTo(destino); return; }   // ya cerrada: no cerrar dos veces

            doorShut();
            doorSwapTimer = setTimeout(function () {
                doorSwapTimer = null;
                doorSwapTo(destino);
            }, 620);
        }

        for (var s = 0; s < doorSwapLabels.length; s++) {
            doorSwapLabels[s].addEventListener('click', doorOnSwapClick);
        }

        // ── Arrastre. Pointer Events unifica ratón, dedo y lápiz en un camino.
        var DRAG_THRESHOLD = 8;      // px antes de considerarlo arrastre: por debajo
                                     // sigue siendo un clic y el logo sigue siendo enlace
        var FLICK_SPEED = 0.5;       // px/ms a partir de los cuales basta el impulso
        var dragging = false, decided = false, justDragged = false;
        var startX = 0, lastX = 0, lastT = 0, travel = 0, fromShut = false;

        function doorTravelPx() {
            return brand ? brand.getBoundingClientRect().width : 540;
        }

        brand.addEventListener('pointerdown', function (ev) {
            if (!doorEnabled() || ev.button > 0) return;
            dragging = true; decided = false; justDragged = false;
            startX = lastX = ev.clientX; lastT = ev.timeStamp; travel = 0;
            fromShut = doorIsShut();
            // dragging YA vale true en la línea de arriba: si esto lanzara
            // (InvalidPointerId si el puntero se soltó entre medias, o
            // NotSupportedError en implementaciones parciales), la excepción
            // saldría del handler con el arrastre a medio armar — puerta
            // colgada con --almc-auth-door-x inline pegado y las transiciones
            // desactivadas hasta el siguiente arrastre. La captura es una
            // MEJORA (seguir el puntero fuera del panel), no un requisito: sin
            // ella el arrastre sigue funcionando dentro del elemento.
            try { brand.setPointerCapture(ev.pointerId); } catch (e) { /* se arrastra igual */ }
        });

        brand.addEventListener('pointermove', function (ev) {
            if (!dragging) return;
            var dx = ev.clientX - startX;

            if (!decided) {
                if (Math.abs(dx) < DRAG_THRESHOLD) return;
                decided = true;
                doorStage.classList.add('almc-auth-door-dragging');
            }

            // El sentido de apertura depende de la pantalla: en login la puerta
            // abre hacia la derecha, en registro hacia la izquierda.
            var openSign = radios.register && radios.register.checked ? -1 : 1;
            var span = doorTravelPx();
            var base = fromShut ? 0 : span * openSign;
            var pos = base + dx;

            // Acotado entre cerrada (0) y abierta (span * openSign).
            var lo = Math.min(0, span * openSign), hi = Math.max(0, span * openSign);
            pos = Math.max(lo, Math.min(hi, pos));

            travel = Math.abs(pos - span * openSign) / span;   // 1 = cerrada
            doorStage.style.setProperty('--almc-auth-door-x', (pos - span * openSign) + 'px');
            doorSpin(travel);

            lastX = ev.clientX; lastT = ev.timeStamp;
        });

        function endDrag(ev) {
            if (!dragging) return;
            dragging = false;
            doorStage.classList.remove('almc-auth-door-dragging');
            doorStage.style.removeProperty('--almc-auth-door-x');
            if (!decided) return;                       // fue un clic, ya lo trata su listener

            // El click sintético que sigue a un pointerup real llega SIEMPRE
            // (el umbral no lo suprime, solo decide si esto fue arrastre). Un
            // pointercancel en cambio no genera click, así que no hace falta
            // (ni conviene) armar la guarda: quedaría pendiente de por vida.
            if (ev.type === 'pointerup') justDragged = true;

            var dt = Math.max(1, ev.timeStamp - lastT);
            var speed = Math.abs(ev.clientX - lastX) / dt;

            // Engancha por impulso si fue un golpe seco, o por recorrido si no.
            // Nunca queda a medias.
            var shut = speed > FLICK_SPEED
                ? (ev.clientX - startX) * (radios.register && radios.register.checked ? -1 : 1) < 0
                : travel > .5;

            if (shut) doorShut(); else doorOpen();
        }

        brand.addEventListener('pointerup', endDrag);
        brand.addEventListener('pointercancel', endDrag);

        // WCAG 2.4.11 (Focus Not Obscured): con la puerta cerrada los campos del
        // formulario reciben foco estando 100% tapados por un panel opaco. En vez
        // de marcarlos inertes —que convertiría la puerta en una trampa real si
        // alguna vía de apertura fallara, y obligaría a una región role="status" y
        // a mover el foco en los tres caminos automáticos— se invierte la relación:
        // llegar al formulario ABRE la puerta. El peor caso pasa a ser una puerta
        // que se abre de más, no una que no se abre.
        //
        // M2 (revisión final): esto también dispara con un envío EN VUELO. Si el
        // submit llegó con Enter desde un campo, submitAjax() (§ 3) cierra la
        // puerta con el foco TODAVÍA dentro del formulario; si el usuario tabula
        // mientras espera la respuesta, este mismo listener reabre la puerta en
        // mitad del envío — antes se quedaba cerrada hasta handleResponse(). Es
        // el comportamiento CORRECTO según 2.4.11 (el foco no puede quedar
        // tapado, ni siquiera con una petición en curso), pero es la única de
        // las cinco vías que reabre sin que el usuario haya terminado su gesto.
        // Efecto solo cosmético: el botón sigue disabled/busy, doorArmRescue()
        // sigue vigilando el envío, y el setTimeout(…, 620) de handleResponse()
        // en el camino de éxito ("para que el gesto se vea completo") sigue
        // esperando igual — ahora sobre una puerta que ya estaba abierta.
        var doorForms = doorStage.querySelector('.almc-auth-forms');
        // Sin fallback a '.almc-auth-2fa-form': ese formulario vive DENTRO de
        // <section class="almc-auth-forms"> en challenge.blade.php, igual que
        // el sliding en sliding.blade.php, así que el selector de arriba
        // siempre encuentra contenedor en las dos vistas — no hay un segundo
        // caso que cubrir. No es lo mismo que el fallback de doorOpen() (más
        // arriba, '.almc-auth-form--' + pantalla): ese SÍ hace falta, porque
        // busca una clase que no existe en absoluto en el reto 2FA.
        function doorOpenOnFocus() { if (doorIsShut()) doorOpen(); }
        if (doorForms) doorForms.addEventListener('focusin', doorOpenOnFocus);
        // Los radios son hermanos PREVIOS de <main> (sliding.blade.php): NO son
        // descendientes de doorForms, así que su focusin no burbujea hasta el
        // listener de arriba. Y su único anillo de foco lo pinta el CSS sobre
        // el card de la pantalla activa (#almc-auth-r-login:focus-visible ~
        // .almc-auth-stage .almc-auth-form--login .almc-auth-card, en
        // saas-auth.css), que vive en .almc-auth-forms (z-index 1) — detrás de
        // .almc-auth-brand (z-index 3) mientras la puerta está cerrada. Sin
        // este segundo listener, la primera parada de tabulación de la página
        // entera (el radio marcado, único tab-stop del radiogroup) se queda a
        // oscuras: la misma clase de fallo 2.4.11 que este bloque existe para
        // cerrar, en la misma pantalla.
        //
        // Comprobado que esto NO dispara en los caminos automáticos: asignar
        // radios[x].checked = true por código (doorSwapTo y el popstate de
        // § 1) es una propiedad, no una interacción — no mueve el foco ni
        // dispara 'focus', y el 'change' sintético que sigue (dispatchEvent)
        // tampoco lo hace. El único sitio que activa un radio por clic o
        // teclado, doorOnSwapClick (label.click(), más arriba en este bloque),
        // llama ev.preventDefault() antes de que corra la activación nativa
        // del <label> — por eso tampoco reenfoca el radio esa vía. Solo un Tab
        // o una flecha reales del usuario dentro del radiogroup lo enfocan.
        for (var rr = 0; rr < SCREENS.length; rr++) {
            if (radios[SCREENS[rr]]) radios[SCREENS[rr]].addEventListener('focus', doorOpenOnFocus);
        }

        // La pista solo tiene sentido si la puerta llegó a cerrarse.
        doorArmHint();

        // ── El mecanismo de apertura ya está montado ──────────────────────────
        // Estas tres líneas van LAS ÚLTIMAS del bloque a propósito: firman que
        // clic, teclado y arrastre están enganchados de verdad. Si algo de
        // arriba lanzara, no se ejecutan y el rescate de 4s del inline sigue
        // siendo la red — que es justo lo que debe pasar.
        doorReady = true;
        doorArmBackup();
        // La marca que desarma el rescate de 4s de la vista. La condición NO es
        // "el bundle cargó" sino "el mecanismo de apertura quedó instalado",
        // que es más estricta: con el bundle vivo la puerta espera al usuario y
        // el tironcito se ve las veces que haga falta, en vez de que un
        // temporizador abra por él a los 4,0s (el primer pico del tironcito cae
        // a los 3,788s: 212ms de vida, una sola vez).
        document.documentElement.setAttribute('data-almc-door-live', '1');
        // Arranque inicial del vídeo. Hace falta una línea propia porque el
        // cierre de la carga NO lo pone doorShut() —lo pone el script inline de
        // la vista marcando el <html> durante el parseo, para que el primer
        // pintado ya salga con la puerta echada—, así que el doorVideoPlay() que
        // doorShut() lleva dentro nunca llega a ejecutarse en ese camino. Sin
        // esto el hueco arrancaría con el fotograma congelado (o negro, porque
        // el data-src ni se habría copiado) justo en el único momento en que la
        // puerta está cerrada seguro y el vídeo es todo lo que se ve.
        if (doorIsShut()) { doorVideoPlay(); }
    }
})();
